import { render, staticRenderFns } from "./AssessmentGroupEvaluationCriteriaTable.vue?vue&type=template&id=61741928&scoped=true"
import script from "./AssessmentGroupEvaluationCriteriaTable.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupEvaluationCriteriaTable.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupEvaluationCriteriaTable.vue?vue&type=style&index=0&id=61741928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61741928",
  null
  
)

export default component.exports